import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { POSTS, getPublishedPosts } from "../blogData";
import { Navbar } from "../components/Navbar";
import { Contact, Footer } from "../components/Contact";
import { LeadMagnet } from "../components/LeadMagnet";
import { Reveal } from "../components/Reveal";
import { setSeo } from "../lib/seo";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export default function Blog() {
  useEffect(() => {
    setSeo({
      title: "Real Estate Blog | Melissa O'Donnell — Redlands, Palm Springs & Temecula",
      description: "Expert real estate tips and local market insight for buying, selling, and investing in Redlands, Palm Springs, Temecula, and the Inland Empire."
    });
  }, []);

  return (
    <>
      <Navbar />
      <main data-testid="blog-page">
        <section className="pt-36 pb-16 md:pb-20 bg-[#0a0a0a] text-white">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <p className="eyebrow text-gold mb-4">The Blog</p>
            <h1 className="font-heading font-light text-5xl sm:text-6xl tracking-tight leading-none max-w-3xl">
              Real estate insight for Southern California
            </h1>
            <p className="text-white/70 font-light text-lg mt-6 max-w-xl">
              Expert tips on buying, selling, and investing across Redlands, Palm Springs, Temecula, and the Inland Empire.
            </p>
          </div>
        </section>

        <section className="py-20 md:py-28 bg-white">
          <div className="max-w-7xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {getPublishedPosts().map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block border border-black/5 h-full hover:-translate-y-1 hover:shadow-xl transition-all duration-300 bg-surface">
                  <div className="p-8 flex flex-col h-full">
                    <span className="eyebrow text-[10px] text-gold">{p.category}</span>
                    <h2 className="font-heading text-2xl mt-3 leading-snug group-hover:text-gold transition-colors">{p.title}</h2>
                    <p className="text-[#52525b] font-light text-sm mt-3 leading-relaxed flex-1">{p.excerpt}</p>
                    <div className="flex items-center gap-4 mt-6 pt-5 border-t border-black/5 text-[#a1a1aa] text-xs">
                      <span className="flex items-center gap-1.5"><Calendar size={13} /> {fmtDate(p.date)}</span>
                      <span className="flex items-center gap-1.5"><Clock size={13} /> {p.readTime}</span>
                    </div>
                    <span className="inline-flex items-center gap-1.5 text-sm mt-5 text-[#0a0a0a] group-hover:text-gold transition-colors">
                      Read more <ArrowRight size={15} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </section>
        <LeadMagnet />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
